<template>
  <div>
    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <v-expansion-panels accordion mandatory v-model="current_panel">
          <v-expansion-panel v-for="category in categories" :key="category.id">
            <v-expansion-panel-header class="back-ground-grey2">
              <h6 class="mb-0 upper-text">
                <span class="worksansr">CATEGORIA:</span> {{ category.name }}
                <br />
                <span class="worksansr text-thirteen"
                  >({{ category.questions.length }}
                  {{
                    category.questions.length > 1 ? "perguntas" : "pergunta"
                  }})</span
                >
              </h6>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div
                class="row"
                v-for="(question, question_index) in category.questions"
                :key="question.id"
              >
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <h6>
                    {{ question_index + 1 }}. {{ question.statement }}
                    <span class="mandatory-data worksansr">
                      {{ question.mandatory == 1 ? "(Obrigatório)" : "" }}</span
                    >
                  </h6>
                  <Open
                    v-if="question.semiology_form_question_type_value == 'OPEN'"
                    :question="question"
                    :category_id="category.id"
                    v-on:answer="handleChangeAnswerQuestions"
                  />
                  <Rating
                    v-if="
                      question.semiology_form_question_type_value == 'RATING'
                    "
                    :category_id="category.id"
                    :question="question"
                    v-on:answer="handleChangeAnswerQuestions"
                  />
                  <SingleChoice
                    v-if="
                      question.semiology_form_question_type_value ==
                      'SINGLE_CHOICE'
                    "
                    :category_id="category.id"
                    :question="question"
                    v-on:answer="handleChangeAnswerQuestions"
                  />
                  <MultipleChoice
                    v-if="
                      question.semiology_form_question_type_value ==
                      'MULTIPLE_CHOICE'
                    "
                    :category_id="category.id"
                    :question="question"
                    v-on:answer="handleChangeAnswerQuestions"
                  />
                  <Dichotomous
                    v-if="
                      question.semiology_form_question_type_value ==
                      'DICHOTOMOUS'
                    "
                    :category_id="category.id"
                    :question="question"
                    v-on:answer="handleChangeAnswerQuestions"
                  />
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
    <ErrorsMessages :errors="errors" />
    <div class="row">
      <div
        class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 check-text-center"
      >
        <confirmation-dialog
          :disabled="loading"
          message-title="CANCELAR?"
          header-class="modal-header-red"
          yesClass="btn-delete worksansr"
          message-body="Tem certeza que deseja cancelar? Não é possível retornar."
          open-text="CANCELAR"
          open-class="btn-cancel m-1"
          @yes="$emit('return')"
        />
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 check-text-right">
        <strong v-if="total > 1" class="text-fifteen upper-text p-2 m-1">
          {{ current + 1 }} de {{ total }} residentes</strong
        >
        <confirmation-dialog
          :disabled="loading"
          message-title="Enviar formulário?"
          message-body="O formulario será salvo e você ira para o proximo residente."
          :open-text="
            total > 1
              ? current == total - 1
                ? 'CONCLUIR'
                : 'AVANÇAR'
              : 'SALVAR'
          "
          header-class="modal-header-ok"
          yesClass="btn-save worksansr"
          open-class="btn-save m-1"
          open-left-icon="fa-check mr-2"
          @yes="answerQuestions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../../services/api";

import Open from "./Question/Open";
import Rating from "./Question/Rating";
import SingleChoice from "./Question/SingleChoice";
import MultipleChoice from "./Question/MultipleChoice";
import Dichotomous from "./Question/Dichotomous";

import ErrorsMessages from "../../Components/ErrorsMessages";

import toast from "../../../lib/ToastNotification";
import ConfirmationDialog from "../../Components/ConfirmationDialog.vue";

export default {
  name: "FormWithProps",
  components: {
    Open,
    Rating,
    SingleChoice,
    MultipleChoice,
    Dichotomous,
    ErrorsMessages,
    ConfirmationDialog,
  },
  props: {
    resident: [Object, undefined],
    semiology_form: [Object, undefined],
    current: { type: Number, required: true, default: 0 },
    total: { type: Number, required: true, default: 0 },
  },
  watch: {
    resident: function () {
      this.reset().then();
    },
  },
  data() {
    return {
      categories: [],
      answer: [],
      errors: [],
      loading: false,
      current_panel: 0,
      MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
      DICHOTOMOUS: "DICHOTOMOUS",
      SINGLE_CHOICE: "SINGLE_CHOICE",
      RATING: "RATING",
      OPEN: "OPEN",
    };
  },
  created() {
    this.get().then();
  },
  methods: {
    handleChangeAnswerQuestions(e) {
      let { answer } = this;

      for (let item of answer) {
        if (item.category_id == e.category_id) {
          for (let question of item.questions) {
            if (question.id == e.id) {
              question.answer = e.answer;
              question.text = e.text;
            }
          }
        }
      }

      this.answer = answer;
    },
    async get() {
      try {
        this.loading = true;

        let params = { id: this.semiology_form.id };

        let response = await api.get("/rest-home/answer-semiology/form", {
          params,
        });

        let { error, errors, categories } = response.data;
        if (!error) {
          let answer = [];
          for (let category of categories) {
            let questions = [];
            for (let item of category.questions) {
              questions.push({
                id: item.id,
                mandatory: item.mandatory,
                statement: item.statement,
                semiology_form_question_type_value:
                  item.semiology_form_question_type_value,
              });
            }
            answer.push({
              category_id: category.id,
              category_name: category.name,
              questions,
            });
          }
          this.answer = answer;
          this.categories = categories;
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async answerQuestions() {
      try {
        this.loading = true;

        let params = {
          resident_id: this.resident.id,
          id: this.semiology_form.id,
          answer: this.answer,
        };
        const response = await api.post(
          "/rest-home/answer-semiology/form",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("anwered");
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async reset() {
      this.current_panel = 0;
      this.categories = [];
      this.answer = [];
      this.errors = [];
      this.loading = false;

      await this.get();
    },
  },
};
</script>
